import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    BVM_VIN_WARN001: {
        id: 'warnings.bvm.dataNotFound',
        defaultMessage: 'No data found in BVM for the VIN {vinNumber}'
    },
    ASE_TECHNICAL_BULLETIN_NUMBER_WARN001: {
        id: 'warnings.technicalBulletin.alreadyExists',
        defaultMessage: 'Ticket(s) with this technical bulletin number already exists! See '
    }
});

export default messages;
